import styled from 'styled-components'
import { IconV2 } from 'ui/components'

export const ConnectedIcon = styled(IconV2)`
  color: var(--theme-colors-theme-brand-primary);
`

export const NoConnectedIcon = styled(IconV2)`
  color: var(--theme-colors-theme-negative-main);
`
